import React, { useEffect, useState } from 'react'
import { useDialogOpened } from '../../utils/hooks/useDialogOpened'
import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogContent, Box, DialogActions, Typography, TextField } from '@mui/material'
import { AccountDtoPermission, AdopterDto } from '../../interactors/gen/backendClient'
import { blue } from '../theme'
import { useAccountsStore } from '../../store/AccountsStore'
import { Edit } from '@mui/icons-material'

interface Props {
  onSubmit: (data: Partial<AdopterDto>) => Promise<void>
  initialComment?: string
}

export const EditFormCustomerCommentModal: React.FC<Props> = ({ onSubmit, initialComment }) => {
  const { isDialogOpen, openDialog, closeDialog } = useDialogOpened()
  const [customerComments, setCustomerComments] = useState<string>(initialComment || '')

  useEffect(() => {
    if (initialComment) {
      setCustomerComments(initialComment)
    }
  }, [initialComment])

  const accountsStore = useAccountsStore()
  const isReader = accountsStore.connectedAccount?.permission === AccountDtoPermission.Read

  const onSubmitPastAdoption = async () => {
    await onSubmit({
      adoptionForm: {
        customerComments: customerComments,
      },
    })
    closeDialog()
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={() => openDialog()} disabled={isReader}>
        <Edit sx={{ mr: 1, width: 20, height: 20 }} />
        Modifier les infos
      </Button>
      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        PaperProps={{
          style: { borderRadius: 15, padding: 15 },
        }}
      >
        <DialogContent>
          <Box>
            <Typography variant="body2" sx={{ color: blue, fontSize: 20, fontWeight: 700 }}>
              Vous pouvez modifier le commentaire avec toutes les informations que vous avez sur l&#39;adoptant
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              value={customerComments}
              onChange={(e) => setCustomerComments(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              closeDialog()
              setCustomerComments(initialComment || '')
            }}
          >
            Annuler
          </Button>

          <LoadingButton data-testid="apply-changes" variant="contained" onClick={() => onSubmitPastAdoption()}>
            {'Enregistrer'}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  )
}
